import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import awardOutline from '@iconify/icons-eva/award-outline';
import { LinkasRouterLink, useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import isEligible from '../../../utils/roleEligibleGetter';

// ----------------------------------------------------------------------

UserMoreMenu.propTypes = {
  onDelete: PropTypes.func.isRequired,
  rowData: PropTypes.object.isRequired
};
export default function UserMoreMenu({ onDelete, rowData }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => navigate(`/dashboard/uat/${rowData.id}`)}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem
          onClick={() => navigate(`/dashboard/services/${rowData.idRekomendasi}?navigateBack=uat`)}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemIcon>
            <Icon icon={awardOutline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Lihat Rekomendasi" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        {isEligible('delete_uat') && (
          <MenuItem sx={{ color: 'red' }} onClick={() => onDelete(rowData)}>
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
